<template>
    <div class="my-panel">
        <div class="my-panel__hd">
            <h3>获取草根值方式3</h3>
        </div>
        <div class="my-panel__bd panel_style ">
            <div class="text-tip">购买商城商品</div>
            <k-hr size="30"></k-hr>
            <div class="goods-body">
                <img v-if="isInMobile" src="../../../assets/img/biaoge.png" width="100%" alt="">
                <img v-else src="../../../assets/img/biaoge-pc.png" width="100%" alt="">
                <div class="goods-a">
                    <a v-for="(item,index) in goodsList" :key="index" :href="item.url"></a>
                </div>
            </div>
            <br>
            <div class="ta-center">
                <div><a :href="shopUrl" class="btn-yellow btn-round">去商城选购更多商品</a></div>
                <br>
                <div class="cl-org fts-24">特别说明：若发生商品退货退款，导致草根值不足1万，会对身份降级。</div>
            </div>
            
        </div>
        
    </div>
</template>
<script>
    import {HOST_BBS} from '../../../const'
    import {mapState} from 'vuex'
    import { isInMobile } from '../../../utils/base'
    export default {
        data() {
            return {
                isInMobile : isInMobile(),
                shopUrl : 'https://'+HOST_BBS + '/plugin.php?id=wei_shop:wei_shop',
                /* goodsList: [
                    {id: 1, name: '速成班U盘', price : 4688, exp:7735, url:  'https://'+HOST_BBS + '/plugin.php?id=wei_shop&mod=product&pid=94'},
                    {id: 2, name: '速成班U盘+斗K1年', price : 5588, exp:9220, url: 'https://'+HOST_BBS + '/plugin.php?id=wei_shop&mod=product&pid=95'},
                    {id: 3, name: '斗K1年', price : 1998, exp:3300, url:'/kline/award/sale'},
                    {id: 4, name: '王者财经学院三套合集', price : 2888, exp:2888, url: 'https://'+HOST_BBS + ''},
                    {id: 5, name: '股道纵横', price : 288, exp:288, url: 'https://'+HOST_BBS +'/plugin.php?id=wei_shop&mod=product&pid=47'},
                    {id: 6, name: '邮票册（狗年）', price : 208, exp:208, url: 'https://'+HOST_BBS + '/plugin.php?id=wei_shop&mod=product&pid=48'},
                ] */
            }
        },
        computed: {
            ...mapState('config', ['wzConfig']),
            goodsList(){
                return this.wzConfig.goodsList || []
            }
        },
    }
</script>